import { Pipe, PipeTransform } from '@angular/core';
import {CardDto} from '../../../_services/configuration-services';

@Pipe({
    name: 'rfidCardsToInlineText',
    standalone: false
})
export class RfidCardsToInlineTextPipe implements PipeTransform {

  transform(cards: Array<CardDto>, sep = ' - '): string {
      return cards.map(card => card.cardNumber).join(sep);
  }

}
